module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/217.6b4d5293.png";